<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <!-- 戻るボタン -->
        <div class="l-top-navi__back-area">
          <a id="seatmap-subheader-link1" (click)="backEvent()" class="l-top-navi__back-link u-focus-cursor-pointer">
            <span class="u-visually-hidden" [innerHTML]="'label.goBack' | staticMsg"></span>
          </a>
        </div>
        <!-- 画面タイトル -->
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="title | staticMsg"></h1>
        </div>
        <!-- [ヘッダー下メニュー ボタンエリア] -->
        <div class="l-top-navi__function-area">
          <!-- 指定状況詳細(PNR)モーダル表示ボタン -->
          <div class="l-top-navi__function-item">
            <button
              id="seatmap-subheader-1"
              class="l-top-navi__function-btn"
              [disabled]="isDisabledConfirm"
              [ngClass]="{ 'cursor-reset': isDisabledConfirm }"
              (click)="confirmEvent()"
            >
              <span
                class="l-top-navi__function-btn--confirm-text"
                [innerHTML]="'m_static_message-label.confirm1' | staticMsg"
              ></span>
            </button>
          </div>
        </div>
        <!-- //[ヘッダー下メニュー ボタンエリア] -->

        <!-- [ステップナビゲーション] -->
        <div class="l-top-navi__progress-area">
          <ol class="l-top-navi__progress-list">
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.first' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.flightSearch' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active">
              <em class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.second' | staticMsg"></span>
                <span
                  class="l-top-navi__progress-text"
                  [innerHTML]="'label.passengerInformationInput' | staticMsg"
                ></span>
              </em>
            </li>
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active l-top-navi__progress-item--current">
              <div class="l-top-navi__progress-wrap">
                <span class="u-visually-hidden" [innerHTML]="'alt.stepBar' | staticMsg : { '0': 5, '1': 3 }"></span>
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.third' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.suchAsSeatAssign' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.fourth' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.purchase2' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.fifth' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.complete' | staticMsg"></span>
              </div>
            </li>
          </ol>
        </div>
        <!-- //[ステップナビゲーション] -->

        <!--
        /=====================================================
        アクセシビリティ対応（読み上げ対策）のため、
        SP/TABの際は[ヘッダー下メニュー ボタンエリア] 、[ステップナビゲーション]の順でhtmlを出力してください
        PCの際は[ステップナビゲーション]、[ヘッダー下メニュー ボタンエリア]の順でhtmlを出力してください
        =====================================================/
        -->
      </div>
    </div>
  </div>
</div>
